class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.closeBtn = this.querySelector('button[type="button"]');
    this.resetBtn = this.querySelector('button[type="reset"]');
    this.searchInput = this.querySelector('input[type="search"]');

    // Si la structure attendue n'est pas présente, on sort proprement
    if (!this.detailsContainer || !this.summaryToggle) return;

    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') this.close();
    });

    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.close.bind(this));
    }

    if (this.resetBtn) {
      this.resetBtn.addEventListener('click', this.reset.bind(this));
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  onSummaryClick(event) {
    event.preventDefault();
    const details = event.target.closest('details');
    if (!details) return;

    details.hasAttribute('open') ? this.close() : this.open();
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close();
    }
  }

  open() {
    if (!this.detailsContainer) return;

    if (typeof setScrollbarWidth === 'function') setScrollbarWidth();
    if (typeof setHeaderBottomPosition === 'function') setHeaderBottomPosition();

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('search-modal--open');

    const focusContainer = this.detailsContainer.querySelector('[tabindex="-1"]');
    const focusInput = this.detailsContainer.querySelector('input:not([type="hidden"])');

    if (typeof trapFocus === 'function' && focusContainer && focusInput) {
      trapFocus(focusContainer, focusInput);
    }
  }

  close() {
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    if (this.detailsContainer) this.detailsContainer.removeAttribute('open');

    if (this.onBodyClickEvent) {
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }

    document.body.classList.remove('search-modal--open');
    document.dispatchEvent(new CustomEvent('searchmodal:close'));
  }

  reset(event) {
    event.preventDefault();
    if (this.searchInput) this.searchInput.value = '';
  }
}

if (!customElements.get('search-modal')) {
  customElements.define('search-modal', SearchModal);
}
